import type { OptionMenuItem } from '@getaccept/lib-shared-new/src/options-menu/types/option-menu-item';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import { fallbackParagraphContent } from '@getaccept/editor-lib-new';
import type { TextContentDoc } from '@getaccept/lib-shared-new/src/types/text-content';
import { PostMenuOption } from '../types/enums/post-menu-option';
import type { Post } from '../../types';
import type { UpdatePostPayload } from '../../types/post';
export class PostHelper {
  static getMenuOptions = (): OptionMenuItem[] => [
    {
      title: t('dr_feed_edit_post'),
      icon: 'edit',
      callback: PostMenuOption.Edit,
    },
    {
      title: t('[dr]_platformconcept_feed_delete_post'),
      icon: 'delete-bin',
      class: 'delete-option',
      callback: PostMenuOption.Delete,
    },
  ];

  static filterPosts = (posts: Post[], postId: string): Post[] =>
    posts.filter(({ id }) => id !== postId);

  static updatePosts = (posts: Post[], payload: UpdatePostPayload): Post[] => {
    const { media, text } = payload;
    return posts.map(post => (post.id === payload.postId ? { ...post, media, text } : { ...post }));
  };

  static isEmptyText = (text: string | TextContentDoc) =>
    !text || text === fallbackParagraphContent;
}
